import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { MultiSelect } from '@/components/ui/MultiSelect';
import { Switch } from '@/components/ui/Switch';
import { Textarea } from '@/components/ui/Textarea';
import { t } from '@/lib/i18n';
import type { EditorState } from '../roleContractEditorState';
import { QC_TYPE_OPTIONS } from '../roleContractEditorState';

interface Props {
  state: EditorState;
  setState: React.Dispatch<React.SetStateAction<EditorState>>;
}

export function QcDutiesSection({ state, setState }: Props) {
  return (
    <Card>
      <CardHeader><CardTitle>{t('QC Duties')}</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        {/* Sven dogfood 2026-05-03: founders asked how the checklist
            is used. Help text explains the loop. */}
        <p className="text-sm text-muted-foreground">
          {t('What gets checked when a deliverable from this role goes through Quality Confirmation. The AI Operator runs each checklist item through self-QC before submitting; humans use the same list as a peer-review checklist.')}
        </p>
        <Switch
          checked={state.qcCanPerform}
          onChange={(e) => setState((s) => ({ ...s, qcCanPerform: e.target.checked }))}
          label={t('Can perform QC')}
        />
        <MultiSelect
          label={t('QC types')}
          options={QC_TYPE_OPTIONS}
          value={state.qcTypes}
          onChange={(v) => setState((s) => ({ ...s, qcTypes: v }))}
        />
        <div>
          <Textarea
            label={t('Quality checklist (one item per line)')}
            rows={5}
            value={state.qcChecklist}
            placeholder={t('Brand voice matches the style guide\nEvery claim is backed by an evidence link\nThe CTA is explicit and actionable\nNo commitments outside approved campaigns')}
            onChange={(e) => setState((s) => ({ ...s, qcChecklist: e.target.value }))}
          />
          <p className="mt-1 text-xs text-muted-foreground">
            {t('Each line becomes one criterion in the AI Self-QC report shown in the Verification Inbox.')}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
